// Listener count filter presets
const LISTENER_PRESETS = [
  { value: 2000, label: '2k+' },
  { value: 10000, label: '10k+' },
  { value: 50000, label: '50k+' },
  { value: 100000, label: '100k+' },
  { value: 500000, label: '500k+' },
];
import React, { useContext } from 'react';

import { Link, useNavigate } from 'react-router-dom';

import i18n from '@I18n';
import { NodeTable } from '../NodeTable';
import { TrackPlayButton } from '../TrackPlayButton';
import { Avatar, Box, Button, Dialog, DialogContent, DialogTitle, FormControl, InputLabel, Grid, Card, CardContent, Skeleton, Typography, Switch, FormControlLabel, IconButton } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { Img } from '../Img';
import { gql, useMutation, useQuery } from '@apollo/client';
import { DashboardLayoutContext } from '../../pages/dashboard/layout';

import { ContactLeadButton } from '../ContactLeadButton';
import { Medal } from '@phosphor-icons/react';
import { TrendArrow } from '../TrendArrow';
import { Tooltip, Chip } from '@mui/material';
import { TrendingUp as TrendingUpIcon } from '@mui/icons-material';
import { getStatusColor, isHotProspect, getDaysUntilFollowup } from '../../utils/leadsHelpers';
import moment from 'moment';
import { AddLogToLeadContainer } from '@/pages/dashboard/lead/[slug]/messages/add';
import { AssignUsersToLeadSelect } from '../AssignUsersToLeadSelect';
import LeadStatus from '../LeadStatus';
import { HBox } from '../HBox';
import { LEAD_STATUS_CODES } from '@/constants';

export const EDIT_LEAD_MUTATION = gql`mutation editLead(
  $slug: String!,
  $whoUsername: String
) {
  editLead(slug: $slug, whoUsername: $whoUsername) {
    lead {
      slug
    }
  }
}`

export const ASSIGN_LEAD_MUTATION = gql`mutation assignLead(
  $slug: String!,
  $username: String
) {
  assignLead(slug: $slug, username: $username) {
    lead {
      slug
    }
  }
}`

const PERFORM_ACTION_ON_LEADS_MUTATION = gql`
mutation performActionOnLeads($slugs: [String!]!, $action: String!) {
  performActionOnLeads(slugs: $slugs, action: $action) {
    leads {
      slug
      contacted
    }
  } 
}`

const USERS_QUERY = gql`
  query {
    moodler {
      users {
        imageUrl
        firstName
        lastName
        username
      }
    }
  }
`

export function LeadlistEntryTable({
  entries,
  loading,
  defaultSortByFieldId,
  defaultSortByDirection,
  onRefetch = () => { },
  emptyText = '',
  showContactButton = false,
  showWho = false,
  emptyHeading = '',
  onCircleBackClicked = () => { console.error('onCircleBackClicked not implemented') },
  emptyIcon = InfoOutlined,
  expanded = false,
  canDelete,
  onDeleteClicked = () => { },
  onNodesChecked = ({ nodes }) => [],
  displayColumns = [],
  minListeners: minListenersProp = 0,
  onMinListenersChange,
  ...props
}) {
  const navigate = useNavigate()
  console.log(entries)
  const [selectedNodeIds, setSelectedNodeIds] = React.useState({})
  // Local state for minListeners filter if not controlled
  const [minListeners, setMinListeners] = React.useState(minListenersProp);
  // View toggle state (true = card view, false = table view)
  const [isCardView, setIsCardView] = React.useState(false);
  // Handler for listener filter change
  const handleListenerFilterChange = (event) => {
    const value = Number(event.target.value);
    setMinListeners(value);
    if (onMinListenersChange) {
      onMinListenersChange(value);
    }
  };
  const [addingLogToLead, setAddingLogToLead] = React.useState(null)
  const {
    unreadNotices
  } = useContext(DashboardLayoutContext)
  const [
    editLead,
    {
      data: editLeadData
    }
  ] = useMutation(
    EDIT_LEAD_MUTATION,
    {
      onCompleted: () => {
        onRefetch()
      }
    }
  )
  const { data: usersData } = useQuery(USERS_QUERY)

  const [performActionOnLeads] = useMutation(PERFORM_ACTION_ON_LEADS_MUTATION, {
    onCompleted: () => {
      onRefetch()
    }
  })

  const [assignLead] = useMutation(ASSIGN_LEAD_MUTATION, {
    onCompleted: () => {
      onRefetch()
    }
  })

  const users = usersData?.moodler?.users ?? []

  const allColumns = [
    {
      id: 'player',
      label: i18n.t('player'),
      render: ({ node }) => {
        console.log(node?.lead)
        return (
          node?.lead?.track && <TrackPlayButton node={node.lead} value={node?.lead?.track} />
        )
      }
    },
    {
      id: 'image',
      label: i18n.t('Image'),
      render: ({ node }) => {
        return <Avatar src={node?.lead?.imageUrl} alt={node?.lead?.name} height="30pt" style={{ aspectRatio: '1/1' }} />
      }
    },
    {
      id: 'name',
      headerStyle: {
        textAlign: 'left',
        width: '30pt'
      },
      sortable: true,
      name: i18n.t('Name'),
      render: ({ node }) => {
        const lead = node.lead;
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Link to={`/dashboard/lead/${lead?.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
              {lead?.name}
            </Link>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {/* Hot prospect cue */}
              {isHotProspect(lead) && (
                <Tooltip title="Hot prospect - Click to view details">
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      console.log('Hot prospect icon clicked!', lead?.slug);
                      e.preventDefault();
                      e.stopPropagation();
                      navigate(`/dashboard/lead/${lead?.slug}`);
                    }}
                    sx={{
                      cursor: 'pointer',
                      bgcolor: 'error.main',
                      color: 'white',
                      '&:hover': { bgcolor: 'error.dark' },
                      ml: 1
                    }}
                  >
                    <TrendingUpIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}

              {/* Follow-up overdue cue */}
              {(() => {
                const daysUntil = getDaysUntilFollowup(lead);
                return daysUntil !== null && daysUntil < 0 && (
                  <Tooltip title="Follow-up overdue - Click to schedule">
                    <Chip
                      label="Overdue"
                      color="error"
                      size="small"
                      onClick={(e) => {
                        console.log('Overdue chip clicked!', lead?.slug);
                        e.preventDefault();
                        e.stopPropagation();
                        onCircleBackClicked({ slug: lead?.slug, lead });
                      }}
                      sx={{ cursor: 'pointer', ml: 1 }}
                    />
                  </Tooltip>
                );
              })()}
            </Box>
          </Box>
        );
      }
    },
    {
      id: 'label',
      headerStyle: {
        textAlign: 'left',
        width: '30pt'
      },
      sortable: true,
      name: i18n.t('Label'),
      render: ({ node }) => {
        return <Link to={`/dashboard/label/${node.lead?.label?.slug}`}>{node.lead?.label?.name}</Link>
      }
    },
    {
      id: 'status',
      sortable: true,
      headerStyle: {
        textAlign: 'left',
        width: '30pt'
      },
      name: i18n.t('status'),
      render: ({ node }) => {
        return <LeadStatus
          status={node.lead.status}
        />
      }
    },
    {
      id: 'spotifyUrl',
      name: i18n.t('Spotify'),
      render: ({ node }) => {
        const { lead } = node
        return (
          <a href={lead.spotifyUrl} target="__blank">
            <img alt="" src="/images/spotify.svg" height="30pt" />
          </a>
        )
      }
    },
    {
      id: 'country',
      name: i18n.t('Country'),
      sortable: true,
      render: ({ node }) => {
        const lead = node?.lead
        return (
          <Img
            alt={lead?.country?.name}
            fallbackSrc={null}
            src={`https://flagcdn.com/32x24/${lead?.country?.identifier?.toLowerCase()}.png`}
            srcSet={`https://flagcdn.com/32x24/${lead?.country?.identifier?.toLowerCase()}.png 2x,
                  https://flagcdn.com/48x36/${lead?.country?.identifier?.toLowerCase()}.png 3x`}

          />
        )
      }
    },
    {
      id: 'monthlyListeners',
      type: 'number',
      name: i18n.t('Monthly listeners'),
      sortable: true,
      headerStyle: {
        textAlign: 'right',
        width: '30pt'
      },
      render: ({ node }) => {
        const { lead } = node
        return (
          <span style={{ fontFamily: 'Courier' }}>{lead.monthlyListeners?.toLocaleString()}</span>
        )
      }
    },
    {
      id: 'monthlyGrowthPercent',
      type: 'number',
      sortable: true,
      name: i18n.t('Monthly growth percent'),
      headerStyle: {
        textAlign: 'right',
        width: '30pt'
      },
      render: ({ node }) => {
        const { lead } = node
        return (
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
            <TrendArrow value={lead.monthlyGrowthPercent} />
            <span style={{ fontFamily: 'Courier' }}>{lead.monthlyGrowthPercent?.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}%</span>
          </Box>
        )
      }
    },
    ...(showContactButton ? [{
      id: 'mark_as_contacted',
      name: i18n.t('Mark as contacted'),
      render: ({ node }) => {
        const lead = node?.lead
        return (
          <ContactLeadButton users={users} lead={lead} />
        )
      }
    }] : []),
    ...(showWho ? [{
      sortable: true,
      id: 'who',
      width: '130pt',
      name: i18n.t('Who'),
      render: ({ node }) => {
        const lead = node?.lead
        return (
          <FormControl sx={{ minWidth: 220 }}>
            <InputLabel>{i18n.t('assigned-to')}</InputLabel>
            <AssignUsersToLeadSelect users={users} lead={lead} onCompleted={() => onRefetch()} />
          </FormControl>
        )
      }
    }] : []),
    {
      sortable: true,
      id: "dspSupportArchieved",
      name: i18n.t('dsp-support-archieved'),
      render: ({ node }) => {
        const lead = node?.lead
        return (
          lead.dspSupportArchieved ? <Medal style={{ filter: 'drop-shadow(0 0 28pt rgb(255 127 0 / 1))' }} size={28} /> : ''
        )
      }
    }/*,
    {
      id: "nextInterventionDate",
      name: i18n.t('Next contact date'),
      sortable: false,
      render: ({ node }) => {
        const lead = node?.lead
        return (
          lead.nextIntervention?.intervened ? moment(lead.nextIntervention?.intervened).format('YYYY-MM-DD') : '-'
        )
      }
    }*/,
    {
      id: "added",
      name: i18n.t('Added'),
      sortable: true,
      render: ({ node }) => {
        return (
          node?.added ? moment(node?.added).format('YYYY-MM-DD') : '-'
        )
      }
    }
  ]
  let columns = allColumns
  if (displayColumns?.length > 0) {
    columns = allColumns.filter(c => displayColumns.find(dc => c.id === dc))
  }

  return (
    <>
      {/* Listener Count Filter Presets */}
      <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
        <span style={{ fontWeight: 500 }}>Min. Listeners:</span>
        <Box>
          {LISTENER_PRESETS.map((preset) => (
            <Button
              key={preset.value}
              variant={minListeners === preset.value ? 'contained' : 'outlined'}
              size="small"
              sx={{ mr: 1, mb: 1 }}
              onClick={() => handleListenerFilterChange({ target: { value: preset.value } })}
            >
              {preset.label}
            </Button>
          ))}
        </Box>
      </Box>

      {/* View Toggle */}
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <FormControlLabel
          control={
            <Switch
              checked={isCardView}
              onChange={(e) => setIsCardView(e.target.checked)}
              size="small"
            />
          }
          label={isCardView ? "Card View" : "Table View"}
        />
      </Box>

      {/* Skeleton loading state as cards */}
      {loading ? (
        isCardView ? (
          <Grid container spacing={2}>
            {[...Array(6)].map((_, index) => (
              <Grid item xs={12} md={6} lg={4} key={index}>
                <Card>
                  <CardContent>
                    <Skeleton variant="text" width="60%" />
                    <Skeleton variant="text" width="80%" />
                    <Skeleton variant="rectangular" height={60} sx={{ mt: 1 }} />
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Box sx={{ p: 2 }}>
            <Skeleton variant="rectangular" width="100%" height={400} />
          </Box>
        )
      ) : isCardView ? (
        <Grid container spacing={2}>
          {(minListeners > 0 ? entries.filter(e => e.lead?.monthlyListeners >= minListeners) : entries).map((entry) => {
            const lead = entry.lead;
            return (
              <Grid item xs={12} md={6} lg={4} key={lead.slug}>
                <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                  <CardContent sx={{ flexGrow: 1 }}>
                    {/* Header */}
                    <Box sx={{ display: 'flex', alignItems: 'start', mb: 2 }}>
                      <Avatar
                        sx={{
                          bgcolor: getStatusColor(lead.status) + '.main',
                          width: 40,
                          height: 40,
                          mr: 2
                        }}
                        src={lead.imageUrl}
                        alt={lead.name}
                      >
                        {lead.name?.charAt(0).toUpperCase()}
                      </Avatar>
                      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                        <Typography variant="h6" sx={{ fontSize: '1rem' }} noWrap>
                          <Link to={`/dashboard/lead/${lead.slug}`}>{lead.name}</Link>
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                          <Chip
                            label={lead.statusDisplay}
                            color={getStatusColor(lead.status)}
                            size="small"
                          />
                          {isHotProspect(lead) && (
                            <Tooltip title="Hot prospect - Click to view details">
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  console.log('Card view: Hot prospect icon clicked!', lead?.slug);
                                  e.preventDefault();
                                  e.stopPropagation();
                                  navigate(`/dashboard/lead/${lead?.slug}`);
                                }}
                                sx={{
                                  cursor: 'pointer',
                                  bgcolor: 'error.main',
                                  color: 'white',
                                  '&:hover': { bgcolor: 'error.dark' }
                                }}
                              >
                                <TrendingUpIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                          {(() => {
                            const daysUntil = getDaysUntilFollowup(lead);
                            return daysUntil !== null && daysUntil < 0 && (
                              <Tooltip title="Follow-up overdue - Click to schedule">
                                <Chip
                                  label="Overdue"
                                  color="error"
                                  size="small"
                                  onClick={(e) => {
                                    console.log('Card view: Overdue chip clicked!', lead?.slug);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onCircleBackClicked({ slug: lead?.slug, lead });
                                  }}
                                  sx={{ cursor: 'pointer' }}
                                />
                              </Tooltip>
                            );
                          })()}
                          <HBox>

                            {lead?.source && (
                              <>
                                <Typography>{i18n.t('from')}</Typography>

                                <Tooltip title={lead?.source?.name}>
                                  <Chip
                                    label={lead?.source?.name}
                                    color="info"
                                    size="small"
                                    sx={{ cursor: 'pointer' }}
                                  />
                                </Tooltip>

                                {lead?.source?.sourceType && (
                                  <>
                                    <Typography>{i18n.t('via')}</Typography>
                                    <Tooltip title={lead?.source?.sourceType?.name}>
                                      <Chip
                                        label={lead?.source?.sourceType?.name}
                                        color="info"
                                        size="small"
                                        sx={{ cursor: 'pointer' }}
                                      />
                                    </Tooltip>
                                  </>
                                )}
                              </>
                            )}
                            {lead?.source?.campaign && (
                              <>
                                <Typography>{i18n.t('in campaign')}</Typography>
                                <Tooltip title={lead?.source?.campaign?.name}>
                                  <Chip
                                    label={lead?.source?.campaign?.name}
                                    color="info"
                                    size="small"
                                    sx={{ cursor: 'pointer' }}
                                  />
                                </Tooltip>
                              </>
                            )}
                          </HBox>
                          {lead?.campaign && (
                            <Tooltip title={lead?.campaign?.name}>
                              <Chip
                                label={lead?.campaign?.name}
                                color="info"
                                size="small"
                                sx={{ cursor: 'pointer' }}
                              />
                            </Tooltip>
                          )}
                        </Box>
                        <Typography variant="body2" color="text.secondary" noWrap>
                          {lead.countryName}
                        </Typography>
                      </Box>
                    </Box>
                    {/* Metrics */}
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                        {lead.monthlyListeners?.toLocaleString()} monthly listeners
                      </Typography>
                      <Typography
                        variant="body2"
                        color={lead.monthlyGrowthPercent > 0 ? 'success.main' : 'text.secondary'}
                      >
                        {lead.monthlyGrowthPercent > 0 ? '+' : ''}{lead.monthlyGrowthPercent?.toFixed(1)}% growth
                      </Typography>
                    </Box>
                    {/* Follow-up Info */}
                    {lead.nextIntervention?.intervened && (
                      <Box sx={{ mb: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                          Follow-up: {moment(lead.nextIntervention.intervened).format('YYYY-MM-DD')}
                          {(() => {
                            const daysUntil = getDaysUntilFollowup(lead);
                            return daysUntil !== null && daysUntil < 0 && (
                              <Chip label="Overdue" color="error" size="small" sx={{ ml: 1 }} />
                            );
                          })()}
                        </Typography>
                      </Box>
                    )}
                    {/* Assignment */}
                    {lead.assignedManager && (
                      <Typography variant="body2" color="text.secondary">
                        Assigned to: {lead.assignedManager}
                      </Typography>
                    )}
                  </CardContent>
                  {/* Actions placeholder: you can add LeadActions or similar here if needed */}
                </Card>
              </Grid>
            );
          })}
        </Grid>
      ) : (
        <NodeTable
          defaultSortByFieldId={defaultSortByFieldId}
          defaultSortByDirection={defaultSortByDirection}
          tabIndex={0}
          loading={false}
          emptyText={emptyText}
          emptyHeading={emptyHeading}
          emptyIcon={emptyIcon}
          expanded={expanded}
          canDelete={true}
          style={{ width: 'auto' }}
          onSelectedNodesChanged={(selectedNodeIds) => {
            setSelectedNodeIds(selectedNodeIds)
          }}
          onDeleteClicked={(nodes) => {
            onDeleteClicked(nodes)
          }}
          draggable={true}
          renderRowClassNames={({ node }) => {
            return node?.lead?.read ? 'row-read' : 'row-unread'
          }}
          onNodesChecked={onNodesChecked}
          getRealNode={({ node }) => {
            return node.lead
          }}
          nodes={minListeners > 0 ? entries.filter(e => e.lead?.monthlyListeners >= minListeners) : entries}
          hasSubRows={true}
          getValueOfNode={
            ({ node, column }) => {
              return node.lead[column.id]
            }
          }
          renderSubRows={({ node, columns }) => {
            return (
              <>
                <tr className={node?.lead?.read ? 'row-read' : 'row-unread'}>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td colSpan={columns.length - 2}>
                    <h3>Next contact date: {node?.lead?.nextIntervention?.intervened ? moment(node?.lead?.nextIntervention?.intervened).format('YYYY-MM-DD') : '-'}</h3>
                    <Button type="primary" variant="contained" onClick={() => setAddingLogToLead(node?.lead)}>{i18n.t('Add note')}</Button>&nbsp;
                    <Button variant="contained" onClick={() => onCircleBackClicked(node)}>{i18n.t('schedule-next-contact')}</Button>
                    {node?.lead?.messages?.map(message => (
                      <article key={message.id}>
                        <p>{moment(message.created).fromNow()}</p>
                        <p>{message.text}</p>
                      </article>
                    ))}
                  </td>
                </tr>
              </>
            )
          }}
          getContextMenuItems={({ nodes }) => [
            {
              name: i18n.t('Edit'),
              onClick: () => {
                navigate(`/dashboard/lead/${nodes[0]?.lead?.slug}`)
              }
            },
            ...(LEAD_STATUS_CODES.map(
              status => ({
                name: i18n.t('mark-as-' + status.name),
                onClick: () => {
                  performActionOnLeads({
                    variables: {
                      action: `mark_as_${status.name}`,
                      slugs: [nodes[0]?.lead?.slug]
                    }
                  }).then(() => onRefetch())
                }
              })
            )), 
            {
              name: i18n.t('Delete'),
              onClick: () => {
                onDeleteClicked(nodes.map(n => n.slug))
              }
            }
          ]}
          columns={columns}
          {...props}
        />
      )}

      {/* Empty State */}
      {!loading && (minListeners > 0 ? entries.filter(e => e.lead?.monthlyListeners >= minListeners) : entries).length === 0 && (
        <Card>
          <CardContent sx={{ textAlign: 'center', py: 6 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              {emptyHeading || 'No leads found'}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              {emptyText || 'Try adjusting your filters or check a different view'}
            </Typography>
            <Button variant="outlined" onClick={() => {
              setMinListeners(0);
              if (onMinListenersChange) onMinListenersChange(0);
            }}>
              Clear filters
            </Button>
          </CardContent>
        </Card>
      )}

      {/* Dialog for adding log to lead remains unchanged */}
      <Dialog open={addingLogToLead} onClose={() => setAddingLogToLead(null)}>
        <DialogTitle>{i18n.t('Add log to lead %s', addingLogToLead?.name)}</DialogTitle>
        <DialogContent>
          {addingLogToLead && (
            <AddLogToLeadContainer
              slug={addingLogToLead?.slug}
              onSaved={() => {
                onRefetch()
                setAddingLogToLead(null)
              }}
            />
          )
          }
        </DialogContent>
      </Dialog>
    </>
  )
}